import { useMemo } from 'react';

import { useAppSelector } from '@/store/hooks';
import { selectBodyAttributesTheme } from '@/store/slices/layout-grid/selectors';
import getComputedColorVariableValue from '../get-computed-color-variable-value';
import { EPaletteModes } from '@/types/theme-packs.types';

const useComputedColorVariableValue = ({
  variable,
  themeMode,
  dynamicKeyPrefix,
}: {
  variable: string;
  themeMode?: EPaletteModes;
  dynamicKeyPrefix?: string | number;
}) => {
  const bodyTheme = useAppSelector(selectBodyAttributesTheme);

  return useMemo(() => {
    return getComputedColorVariableValue(variable, themeMode || bodyTheme, dynamicKeyPrefix);
  }, [bodyTheme, variable, themeMode, dynamicKeyPrefix]);
};

export default useComputedColorVariableValue;
